import React from "react";
import { publishModalData, publishModalProps, publishModalVisibility } from "../../../redux/features/modal/modalSlice";
import BotbCarV2PassModal from "./botbPassModal";
import { useAppDispatch } from "../../../redux/hooks";

const EnterNowButton = (props: { classes?: string; variation?: string; text?: string; place?: string }) => {
  const { classes = "", variation = "", text = "ENTER NOW »", place = "" } = props;
  const dispatch = useAppDispatch();
  const onEnterNow = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(publishModalVisibility({ isOpen: false }));
    dispatch(
      publishModalData({
        modalData: <BotbCarV2PassModal place={place} />,
      })
    );
    dispatch(publishModalProps({ withOverlay: false }));
    dispatch(publishModalVisibility({ isOpen: true }));
  };

  const variations = {
    banner_desktop_btn: {
      button: "min-w-[420px] min-h-16 px-4 rounded shadow-[0_2px_4px_0_rgba(0,0,0,0.70)]",
      fontStyle: "text-2xl leading-6",
      arrow: false,
    },
    mobile_sticky: {
      button: "w-full h-[60px] px-4 gap-[11px] shadow-[inset_0_-60px_0_#FF8200] bg-white",
      fontStyle: "text-base leading-4",
      arrow: true,
    },
    desktop_sticky: {
      button: "min-w-[160px] min-h-12 px-4 gap-[11px] rounded",
      fontStyle: "text-base leading-6",
      arrow: false,
    },
    outline: {
      button: "min-w-[345px] min-h-12 px-4 rounded bg-white border border-solid border-primary",
      fontStyle: "text-base leading-6 text-primary",
      arrow: false,
      outline: true,
    },
    default: {
      button: "min-w-[345px] min-h-12 px-4 rounded",
      fontStyle: "text-base leading-6",
      arrow: false,
    },
  };

  const current = variations[variation] ?? variations.default;
  const isOutline = Boolean((current as { outline?: boolean }).outline);

  return (
    <button
      className={`cursor-pointer uppercase flex justify-center items-center ${isOutline ? "bg-white" : "bg-[#FF8200]"} ${current.button} ${classes}`}
      onClick={onEnterNow}
      aria-label={text}>
      <span
        className={`text-center font-jost font-medium uppercase ${current.fontStyle} ${isOutline ? "text-primary" : "text-white"}`}>
        {text}
      </span>
      {current.arrow && (
        <img className="size-3 shrink-0" src="/assets/images/chevron.png" alt="" width={12} height={12} />
      )}
    </button>
  );
};

export default EnterNowButton;
